import React, { useCallback, useRef, useState } from "react";
import { HexColorPicker } from "react-colorful";

import useClickOutside from "../hooks/useClickOutside";

export const ColorPicker = ({ color, onChange, onSelect }) => {
  const popover = useRef();
  const [isOpen, toggle] = useState(false);

  const close = useCallback(() => toggle(false), []);
  useClickOutside(popover, close);

  return (
    <div className="picker">
      <div
        className="swatch"
        style={{ backgroundColor: color }}
        onClick={() => toggle(true)}
      />
      {console.log({popover})}
      {isOpen && (
        <div className="popover" ref={popover}>
          <HexColorPicker color={color} onSelect={onSelect} onChange={onChange} />
        </div>
      )}
    </div>
  );
};
